import { render } from "./signup-page.vue?vue&type=template&id=42b4d69e"
import script from "./signup-page.vue?vue&type=script&lang=js"
export * from "./signup-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__